// https://github.com/webmodules/jsonp/blob/master/index.js
// converted to TypeScript and promise based
/**
 * Callback index.
 */
let count = 0;
const debug = (..._args) => {
    // console.log.apply(null, ['⏬ JSONP:', ...args]);
};
export class TimeoutError extends Error {
}
export class JsonpAbortControllerSignal {
    constructor() {
        this.onAbortListeners = [];
    }
    add(fn) {
        this.onAbortListeners.push(fn);
    }
    remove(fn) {
        const index = this.onAbortListeners.indexOf(fn);
        if (index > -1) {
            this.onAbortListeners.splice(index, 1);
        }
    }
    abort() {
        for (const fn of this.onAbortListeners) {
            try {
                fn();
            }
            catch (err) { }
        }
        this.onAbortListeners = [];
    }
}
export class JsonpAbortController {
    constructor() {
        this.signal = new JsonpAbortControllerSignal();
    }
    abort() {
        this.signal.abort();
    }
}
const noop = () => { };
function jsonp(url, { param = 'callback', prefix = '__jp', timeout = 60000, name = `${prefix}${count++}`, signal } = {}) {
    return new Promise((resolve, reject) => {
        if (typeof window === 'undefined') {
            reject(new Error('Browser only'));
            return;
        }
        let timer;
        const target = document.getElementsByTagName('script')[0] || document.head;
        let script;
        function cleanup() {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
                debug('script.parentNode.removeChild(script)');
            }
            if (timer) {
                clearTimeout(timer);
                timer = null;
                debug('clearTimeout');
            }
            if (window[name]) {
                window[name] = noop;
                debug('window[name] = noop');
            }
            if (signal) {
                signal.remove(cleanup);
                debug('signal.remove(cleanup)');
            }
        }
        if (timeout) {
            timer = setTimeout(() => {
                cleanup();
                reject(new TimeoutError('Timeout'));
            }, timeout);
        }
        if (signal) {
            signal.add(cleanup);
        }
        window[name] = function (data) {
            debug('jsonp got', data);
            cleanup();
            resolve(data);
        };
        // add querystring component
        url +=
            (url.indexOf('?') > -1 ? '&' : '?') +
                param +
                '=' +
                encodeURIComponent(name);
        debug('jsonp req', url);
        // create script
        script = document.createElement('script');
        script.src = url;
        target.parentNode.insertBefore(script, target);
    });
}
export default jsonp;
//# sourceMappingURL=jsonp.js.map